import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import './styles/Success.css';

const Success = () => {
  return (
    <div style={{minHeight:'100vh',height:'100%'}}>
      <Header />
      <div>

      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default Success
